import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { convertStatusString, dateFormation, isEmpty, isMobilePage, toastr } from '../../common/cores';
import { DoQuestion, GetQuestionList } from '../../common/actions/moreAction';
import Answer from './Answer';
import Blank from './Blank';
import Pagenation from '../common/Pagenation';
import BackButton from './BackButton';
import NavLink from 'react-router-dom/NavLink';
const InquiriesContent = (props) => {

  const [inputs, setInputs] = useState({
    name: '',
    nickname: ''
  });
  const [showHis, setShowHis] = useState(false);

  const [showContent, setShowContent] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { questions, page, setVal, type } = props;

  const { title, question } = inputs; // 비구조화 할당을 통해 값 추출

  const onChange = (e) => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    console.log(e.target)
    setInputs({
      ...inputs, // 기존의 input 객체를 복사한 뒤
      [name]: value // name 키를 가진 값을 value 로 설정
    });
  };

  const onReset = () => {
    setInputs({
      title: '',
      question: '',
    })
  };

  const DoQuestion = () => {
    ;
    console.log(title, question);
    if (isEmpty(title))
      return toastr.warning('제목을 입력해주세요.');
    if (isEmpty(question))
      return toastr.warning('내용을 입력해주세요.');
    if (!props.isAuthenticated)
      return toastr.warning('로그인하시고 이용해주세요.');
    props.DoQuestion({ title, question })
      .then(() => {
        setShowInput(false);
        setSelected(-1);
        GetQuestionList(1);
        setShowHis(!showHis);
      });
  }

  const GetQuestionList = page => {
    props.GetQuestionList({
      page: page,
      perPage: props.page.perPage
    })
  }

  const onShowContent = (index) => {
    if(index === selected) setSelected(-1);
    else setSelected(index);
    setShowInput(false);
    setShowHis(!showHis);
  }

  const cancelQuestion = () => {
    setShowInput(false);
    setShowContent(false);
    setSelected({})
    setShowHis(!showHis);
  }

  const showQuestion = () => {
    setShowInput(true);
    setShowContent(false);
    setSelected({})
    setShowHis(!showHis);
  }

  useEffect(() => {
    GetQuestionList(1);
  }, [props.page.perPage])

  const showHisotry = () => {
    setShowHis(!showHis);
  }

  return (
    <Fragment>
        <div className="con_box10">
          <div className="write_wrap">
            <div className="write3">
              <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                <tbody>
                  <tr>
                    <td className="write_title">제목</td>
                    <td className="write_basic"><input className="input1" onChange={onChange} name="title" size="115" style={{ width: "100%" }} /></td>
                  </tr>
                  <tr>
                    <td className="write_title">내용</td>
                    <td className="write_basic"><textarea cols="115" rows="20" className="input2" style={{ width: "100%" }} name="question" onChange={onChange} ></textarea></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="con_box10">
          <div className="btn_wrap_center">
            <ul>
              <li><a ><span className="btn3_1" onClick={DoQuestion}>문의하기</span></a></li>
            </ul>
          </div>
        </div>
        <div className="con_box50">
          <div className="s_title1">문의목록</div>
        </div>
        <div className="con_box10">
          <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={{borderSpacing: "0px"}}>
            <tbody>
              <tr>
                <td width="10%" className="list_title1">번호</td>

                <td className="list_title1">제목</td>
                <td width="10%" className="list_title1">답변</td>
                <td width="10%" className="list_title1">날짜</td>
              </tr>
              {
                !isEmpty(questions) &&
                questions.map((item, index) => {
                  console.log(item)
                  return (
                    <Fragment key={index}>
                      <tr key={index}>
                        <td className="list1">{index + 1}</td>

                        <td className="list2" onClick={()=>onShowContent(index)}>{item.title}</td>
                        <td className="list1"><span className={item.status == 0 ? "division2" : "division1"}>{item.status == 0 ? "대기중" : "답변완료"}</span></td>
                        <td className="list1">{dateFormation(item.created_date)}</td>
                      </tr>
                      <tr>
                        <td colSpan="4" style={{borderBottom: "1px solid rgba(255, 255, 255, 0.1)", width: "100%", textAlign: "center",}} >
                        <div className="mobile-block ">
                            <div className={`margin-auto ${selected === index ? "notice-div padding-15" : "notice-div-unshow"} w-10 m-w-100 answer`}>문의</div>
                            <div className={` ${selected === index ? "notice-div" : "notice-div-unshow"} w-90 m-w-100 white-break-spaces`} dangerouslySetInnerHTML={{'__html': item.question}}></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="4" style={{borderBottom: "1px solid rgba(255, 255, 255, 0.1)", width: "100%", textAlign: "center",}} >
                          <div className="mobile-block ">
                            <div className={`margin-auto ${selected === index ? "notice-div padding-15" : "notice-div-unshow"} w-10 m-w-100 answer`}>답변</div>
                            <div className={` w-90 ${selected === index ? "notice-div" : "notice-div-unshow"} m-w-100 white-break-spaces`} dangerouslySetInnerHTML={{'__html': item.answer}}></div>
                          </div>
                        </td>
                      </tr>
                  </Fragment>
                  )
                })
              }
            </tbody>

          </table>
        </div>
        <Pagenation page={page.curPage}
          totalPage={page.totalPage}
          getPage={GetQuestionList}
          perPage={10} />
      </Fragment>
  )
}

const mapStateToProps = state => ({
  questions: state.more.custommercenter.data,
  isAuthenticated: state.user.isAuthenticated,
  curPage: state.page.curPage,
  totalPage: state.page.totalPage,
  page: state.page,
  user: state.user
});

export default connect(mapStateToProps, {
  DoQuestion, GetQuestionList
})(InquiriesContent);


// WEBPACK FOOTER //
// ./src/components/account/InquirieContent.js